import { useState, useEffect, useRef } from 'react';
import { NoRecords, PageLoader } from '../../../lib/loader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { WaitingLoader } from '../../../hooks/buttonLoad';
import { useBreadcrumbPagination } from '../../../hooks/useBreadcrumbPagination';
import BreadcrumbPagination from '../../../utils/BreadcrumbPagination';
import { useGetAllNotify } from '../api/apiNotification';



function NotificationHistoryTable() {
    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);

    const { data: getNotifications, isLoading } = useGetAllNotify({

        page: tempPage,
        size: tempRows,
        status: 'read',

    });

    const totalRecords = getNotifications?.data?.count || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    }, []);






    const renderNotificationTable = () => (
        getNotifications?.data?.data?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="Notification history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='text-nowrap' align="center">S.NO</TableCell>
                                    <TableCell className='text-nowrap' align="center">Triggered By</TableCell>
                                    <TableCell className='text-nowrap' align="center">user NAme</TableCell>
                                    <TableCell className='text-nowrap' align="left">Title</TableCell>
                                    <TableCell className='text-nowrap' align="left">Message</TableCell>
                                    <TableCell className='text-nowrap' align="center">Status</TableCell>
                                    <TableCell className='text-nowrap' align="center">
                                        Date & Time

                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getNotifications?.data?.data?.map((row, i) => (
                                    <TableRow key={row?._id || i}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">
                                            {row?.userEmail || "System"}
                                        </TableCell>

                                        <TableCell align="center">
                                            {row?.userName || "s"}
                                        </TableCell>
                                        <TableCell align="left" style={{ fontWeight: row.read ? 'normal' : 'bold' }}>
                                            {row.notifyType}
                                        </TableCell>
                                        <TableCell align="left" style={{ maxWidth: '300px', wordBreak: 'break-word' }}>
                                            {row.notifyMessage}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.readStatus ? (
                                                <span className="text-success">Read</span>
                                            ) : (
                                                <span className="text-warning">Unread</span>
                                            )}
                                        </TableCell>

                                        <TableCell align="center">
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        ) : (
            <NoRecords />
        )
    );

    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    }
    else {
        content = (
            <section>
                <h4>Notification History</h4>
                <div className="ad_pg_bx bg-white p-3">
                    <div className='d-flex justify-content-between align-items-center mb-2'>
                        <div className="col-md-4">

                        </div>
                    </div>
                    {isLoading ? <PageLoader /> : renderNotificationTable()}
                </div>
            </section>
        );
    }




    return <>{content}</>;
}

export default NotificationHistoryTable;